module.exports = __webpack_public_path__ + "img/franchising_hero_cake2.1667f9cc.png";